// Ensure Zone.js is loaded for Angular change detection when used as Elements
import 'zone.js';
import { createApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { BylawsWizardComponent } from './app/tools/bylaws/components/bylaws-wizard/bylaws-wizard.component';
import { FunRunSchedulerComponent } from './app/tools/fun-run-scheduler/fun-run-scheduler.component';
import { FundraisingComparisonComponent } from './app/tools/fundraising-comparison/components/fundraising-comparison/fundraising-comparison.component';
import { FundraisingPlatformCalculatorComponent } from './app/tools/fundraising-comparison/components/fundraising-platform-calculator/fundraising-platform-calculator.component';
import { FundraisingVersusComponent } from './app/tools/fundraising-comparison/components/fundraising-versus/fundraising-versus.component';

function ensureFontsLoaded() {
  const existing = document.querySelector<HTMLLinkElement>(
    'link[data-big-nest-tinos-font]',
  );
  if (existing) {
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href =
    'https://fonts.googleapis.com/css2?family=Tinos:ital,wght@0,400;0,700;1,400;1,700&display=swap';
  link.setAttribute('data-big-nest-tinos-font', 'true');

  document.head.appendChild(link);
}

ensureFontsLoaded();

(async () => {
  const app = await createApplication({
    providers: [provideHttpClient(withFetch())],
  });

  const define = (tag: string, cmp: any) => {
    if (!customElements.get(tag)) {
      customElements.define(
        tag,
        createCustomElement(cmp, { injector: app.injector }),
      );
    }
  };

  define('bylaws-builder', BylawsWizardComponent);
  define('fun-run-scheduler', FunRunSchedulerComponent);
  define('fundraising-comparison', FundraisingComparisonComponent);
  define(
    'fundraising-platform-calculator',
    FundraisingPlatformCalculatorComponent,
  );
  define('fundraising-versus', FundraisingVersusComponent);

  (window as any).__bigNestToolsLoaded = 'main.js loaded';
})();
